module.exports = __webpack_public_path__ + "img/our4.62dad432.png";